import * as Tooltip from '@radix-ui/react-tooltip';

export function ColTooltipProvider({ children }) {
  return <Tooltip.Provider delayDuration={250}>{children}</Tooltip.Provider>;
}

export function ColTooltip({ content, children }) {
  if (!content) return children;
  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content
          className="z-[200] max-w-[280px] rounded bg-n-800 px-2.5 py-1.5 text-[11px] leading-relaxed text-white shadow-lg"
          sideOffset={5}
        >
          {content}
          <Tooltip.Arrow className="fill-n-800" />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
}
